import React from 'react';
import { Button } from '@heroui/react';
import { motion } from 'framer-motion';
import { useLocale } from '../contexts/LocaleContext';

const Hero: React.FC = () => {
  const { t } = useLocale();
  const texts = t;

  return (
  <section id="hero" className="relative py-12 flex items-center justify-center bg-tertiary overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative z-10 px-4 max-w-6xl mx-auto">
  <div className="flex flex-col md:flex-row items-center md:items-start gap-12 md:gap-20">
          {/* Left: texts, CTA, bullets */}
          <div className="w-full md:w-1/2 md:text-left">
            <motion.h1
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              className="text-3xl sm:text-4xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight heading-font"
            >
              {texts.hero.title}
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.1 }}
              className="text-lg md:text-xl text-white/90 mb-8 max-w-xl leading-relaxed body-font"
            >
              {texts.hero.subtitle}
            </motion.p>

            <motion.div
              initial={{ opacity: 0, scale: 0.98 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.15 }}
              className="flex flex-col sm:flex-row gap-6 justify-center items-center"
            >
              <Button
                size="lg"
                className="rounded-lg bg-gradient-primary text-white hover:opacity-90 font-semibold px-8 py-4 text-lg transition-all duration-300 shadow-2xl border border-white/10"
              onClick={() => {
                // default action: scroll to contact form
                const el = document.getElementById('contact');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
                else window.location.hash = '#contact';
              }}
              >
                <span className="heading-font">{texts.hero.cta}</span>
              </Button>
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.25 }}
              className="mt-8 flex flex-col sm:flex-row justify-center items-center gap-8 text-white/80"
            >
              {texts.hero.smallBullets.map((b: string, i: number) => (
                <div key={i} className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-white rounded-full" />
                  <span className="text-sm">{b}</span>
                </div>
              ))}
            </motion.div>
          </div>

          {/* Right: video */}
          {/* 
          <div className="w-full md:w-1/2 flex justify-center md:justify-end">
            <div className="w-full max-w-2xl">
              <Card className="w-full shadow-2xl">
                <CardBody className="p-0">
                  <div className="relative aspect-video bg-gradient-to-br from-primary-gradient1 to-primary-gradient2 rounded-lg overflow-hidden">
                    Replace src with your real video or embed
                    <iframe
                      title="CEO Video"
                      className="absolute inset-0 w-full h-full"
                      src="https://www.youtube.com/embed/dQw4w9WgXcQ"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                </CardBody>
              </Card>
            </div>
          </div> 
          
        */}

        </div>
      </div>
    </section>
  );
};

export default Hero;
